/*
import logo from './logo.svg';
import './App.css';
import Home from "./component/page/home";
import Cart from "./component/page/cart";
import History from "./component/page/history";
import Profile from "./component/page/profile";
import React, {useState} from "react";

function App() {


   const dd =()=>{
    const themeButton = document.getElementById('theme-button')
    const darkTheme = 'dark-theme'
    const iconTheme = 'bx-sun'

// Previously selected topic (if user selected)
const selectedTheme = localStorage.getItem('selected-theme')
const selectedIcon = localStorage.getItem('selected-icon')

// We obtain the current theme that the interface has by validating the dark-theme class
const getCurrentTheme = () => document.body.classList.contains(darkTheme) ? 'dark' : 'light'
const getCurrentIcon = () => themeButton.classList.contains(iconTheme) ? 'bx-moon' : 'bx-sun'

// We validate if the user previously chose a topic
if (selectedTheme) {
  // If the validation is fulfilled, we ask what the issue was to know if we activated or deactivated the dark
  document.body.classList[selectedTheme === 'dark' ? 'add' : 'remove'](darkTheme)
  themeButton.classList[selectedIcon === 'bx-moon' ? 'add' : 'remove'](iconTheme)
}


 document.body.classList.toggle(darkTheme)
    themeButton.classList.toggle(iconTheme)
    // We save the theme and the current icon that the user chose
    localStorage.setItem('selected-theme', getCurrentTheme())
    localStorage.setItem('selected-icon', getCurrentIcon())
  }


  const [page, setPage] = useState(<Home/>)
    const [activeMenu, setActiveMenu] = useState('Home');

     const handlePageChange = (newPage, menuName) => {
    setPage(newPage);
     setActiveMenu(menuName);
  };

      const menuItems = [
    { name: 'Home', component: <Home /> },
    { name: 'Cart', component: <Cart /> },
    { name: 'History', component: <History /> },
    { name: 'User', component: <Profile /> },

  ];


  return (
<body>

  <header className="header" id="header">
    <nav className="nav container">
      <a href="#" className="nav__logo">
        <i className='bx bxs-watch nav__logo-icon'></i> Rolex
      </a>

      <div className="nav__menu" id="nav-menu">
        <ul className="nav__list">
          <li className="nav__item">
            <a href="#home" className="nav__link active-link">Home</a>
          </li>
          <li className="nav__item">
            <a href="#featured" className="nav__link">Featured</a>
          </li>
          <li className="nav__item">
            <a href="#products" className="nav__link">Products</a>
          </li>
          <li className="nav__item">
            <a href="#new" className="nav__link">New</a>
          </li>
        </ul>

        <div className="nav__close" id="nav-close">
          <i className='bx bx-x'></i>
        </div>
      </div>

      <div className="nav__btns">

        <i className='bx bx-moon change-theme' id="theme-button"></i>

        <div className="nav__shop" id="cart-shop">
          <i className='bx bx-shopping-bag'></i>
        </div>

        <div className="nav__toggle" id="nav-toggle">
          <i className='bx bx-grid-alt'></i>
        </div>
      </div>
    </nav>
  </header>


  <div className="cart" id="cart">
    <i className='bx bx-x cart__close' id="cart-close"></i>

    <h2 className="cart__title-center">My Cart</h2>

    <div className="cart__container">
      <article className="cart__card">
        <div className="cart__box">
          <img src="assets/img/featured1.png" alt="" className="cart__img"/>
        </div>

        <div className="cart__details">
          <h3 className="cart__title">Jazzmaster</h3>
          <span className="cart__price">$1050</span>

          <div className="cart__amount">
            <div className="cart__amount-content">
                                <span className="cart__amount-box">
                                    <i className='bx bx-minus'></i>
                                </span>

              <span className="cart__amount-number">1</span>

              <span className="cart__amount-box">
                                    <i className='bx bx-plus'></i>
                                </span>
            </div>

            <i className='bx bx-trash-alt cart__amount-trash'></i>
          </div>
        </div>
      </article>

      <article className="cart__card">
        <div className="cart__box">
          <img src="assets/img/featured3.png" alt="" className="cart__img"/>
        </div>

        <div className="cart__details">
          <h3 className="cart__title">Rose Gold</h3>
          <span className="cart__price">$850</span>

          <div className="cart__amount">
            <div className="cart__amount-content">
                                <span className="cart__amount-box">
                                    <i className='bx bx-minus'></i>
                                </span>

              <span className="cart__amount-number">1</span>

              <span className="cart__amount-box">
                                    <i className='bx bx-plus'></i>
                                </span>
            </div>

            <i className='bx bx-trash-alt cart__amount-trash'></i>
          </div>
        </div>
      </article>

      <article className="cart__card">
        <div className="cart__box">
          <img src="assets/img/new1.png" alt="" className="cart__img"/>
        </div>

        <div className="cart__details">
          <h3 className="cart__title">Longines Rose</h3>
          <span className="cart__price">$980</span>

          <div className="cart__amount">
            <div className="cart__amount-content">
                                <span className="cart__amount-box">
                                    <i className='bx bx-minus'></i>
                                </span>

              <span className="cart__amount-number">1</span>

              <span className="cart__amount-box">
                                    <i className='bx bx-plus'></i>
                                </span>
            </div>

            <i className='bx bx-trash-alt cart__amount-trash'></i>
          </div>
        </div>
      </article>
    </div>

    <div className="cart__prices">
      <span className="cart__prices-item">3 items</span>
      <span className="cart__prices-total">$2880</span>
    </div>
  </div>



      <main className="main">

        <section className="home" id="home">
          <div className="home__container container grid">
            <div className="home__img-bg">
              <img src="assets/img/home.png" alt="" className="home__img"/>
            </div>

            <div className="home__social">
              <a href="https://www.facebook.com/" target="_blank" className="home__social-link">
                Facebook
              </a>
              <a href="https://twitter.com/" target="_blank" className="home__social-link">
                Twitter
              </a>
              <a href="https://www.instagram.com/" target="_blank" className="home__social-link">
                Instagram
              </a>
            </div>

            <div className="home__data">
              <h1 className="home__title">NEW WATCH <br/> COLLECTIONS B720</h1>
              <p className="home__description">
                Latest arrival of the new imported watches of the B720 series,
                with a modern and resistant design.
              </p>
              <span className="home__price">$1245</span>

              <div className="home__btns">
                <a href="#" className="button button--gray button--small">
                  Discover
                </a>

                <button className="button home__button">ADD TO CART</button>
              </div>
            </div>
          </div>
        </section>


        <section className="featured section container" id="featured">
          <h2 className="section__title">
            Featured
          </h2>

          <div className="featured__container grid">
            <article className="featured__card">
              <span className="featured__tag">Sale</span>

              <img src="assets/img/featured1.png" alt="" className="featured__img"/>

                <div className="featured__data">
                  <h3 className="featured__title">Jazzmaster</h3>
                  <span className="featured__price">$1050</span>
                </div>

                <button className="button featured__button">ADD TO CART</button>
            </article>

            <article className="featured__card">
              <span className="featured__tag">Sale</span>

              <img src="assets/img/featured2.png" alt="" className="featured__img"/>

                <div className="featured__data">
                  <h3 className="featured__title">Ingersoll</h3>
                  <span className="featured__price">$250</span>
                </div>

                <button className="button featured__button">ADD TO CART</button>
            </article>

            <article className="featured__card">
              <span className="featured__tag">Sale</span>

              <img src="assets/img/featured3.png" alt="" className="featured__img"/>

                <div className="featured__data">
                  <h3 className="featured__title">Rose gold</h3>
                  <span className="featured__price">$890</span>
                </div>

                <button className="button featured__button">ADD TO CART</button>
            </article>
          </div>
        </section>


        <section className="story section container">
          <div className="story__container grid">
            <div className="story__data">
              <h2 className="section__title story__section-title">
                Our Story
              </h2>

              <h1 className="story__title">
                Inspirational Watch of <br/> this year
              </h1>

              <p className="story__description">
                The latest and modern watches of this year, is available in various
                presentations in this store, discover them now.
              </p>

              <a href="#" className="button button--small">Discover</a>
            </div>

            <div className="story__images">
              <img src="assets/img/story.png" alt="" className="story__img"/>
                <div className="story__square"></div>
            </div>
          </div>
        </section>


        <section className="products section container" id="products">
          <h2 className="section__title">
            Products
          </h2>

          <div className="products__container grid">
            <article className="products__card">
              <img src="assets/img/product1.png" alt="" className="products__img"/>

                <h3 className="products__title">Spirit rose</h3>
                <span className="products__price">$1500</span>

                <button className="products__button">
                  <i className='bx bx-shopping-bag'></i>
                </button>
            </article>

            <article className="products__card">
              <img src="assets/img/product2.png" alt="" className="products__img"/>

                <h3 className="products__title">Khaki pilot</h3>
                <span className="products__price">$1350</span>

                <button className="products__button">
                  <i className='bx bx-shopping-bag'></i>
                </button>
            </article>

            <article className="products__card">
              <img src="assets/img/product3.png" alt="" className="products__img"/>

                <h3 className="products__title">Jubilee black</h3>
                <span className="products__price">$870</span>

                <button className="products__button">
                  <i className='bx bx-shopping-bag'></i>
                </button>
            </article>

            <article className="products__card">
              <img src="assets/img/product4.png" alt="" className="products__img"/>

                <h3 className="products__title">Fosil me3</h3>
                <span className="products__price">$650</span>

                <button className="products__button">
                  <i className='bx bx-shopping-bag'></i>
                </button>
            </article>

            <article className="products__card">
              <img src="assets/img/product5.png" alt="" className="products__img"/>

                <h3 className="products__title">Duchen</h3>
                <span className="products__price">$950</span>

                <button className="products__button">
                  <i className='bx bx-shopping-bag'></i>
                </button>
            </article>
          </div>
        </section>


        <section className="testimonial section container">
          <div className="testimonial__container grid">
            <div className="swiper testimonial-swiper">
              <div className="swiper-wrapper">
                <div className="testimonial__card swiper-slide">
                  <div className="testimonial__quote">
                    <i className='bx bxs-quote-alt-left'></i>
                  </div>
                  <p className="testimonial__description">
                    They are the best watches that one acquires, also they are always with the latest
                    news and trends, with a very comfortable price and especially with the attention
                    you receive, they are always attentive to your questions.
                  </p>
                  <h3 className="testimonial__date">March 27. 2021</h3>

                  <div className="testimonial__perfil">
                    <img src="assets/img/testimonial1.jpg" alt="" className="testimonial__perfil-img"/>

                      <div className="testimonial__perfil-data">
                        <span className="testimonial__perfil-name">Lee Doe</span>
                        <span className="testimonial__perfil-detail">Director of a company</span>
                      </div>
                  </div>
                </div>

                <div className="testimonial__card swiper-slide">
                  <div className="testimonial__quote">
                    <i className='bx bxs-quote-alt-left'></i>
                  </div>
                  <p className="testimonial__description">
                    They are the best watches that one acquires, also they are always with the latest
                    news and trends, with a very comfortable price and especially with the attention
                    you receive, they are always attentive to your questions.
                  </p>
                  <h3 className="testimonial__date">March 27. 2021</h3>

                  <div className="testimonial__perfil">
                    <img src="assets/img/testimonial2.jpg" alt="" className="testimonial__perfil-img"/>

                      <div className="testimonial__perfil-data">
                        <span className="testimonial__perfil-name">Samantha Mey</span>
                        <span className="testimonial__perfil-detail">Director of a company</span>
                      </div>
                  </div>
                </div>

                <div className="testimonial__card swiper-slide">
                  <div className="testimonial__quote">
                    <i className='bx bxs-quote-alt-left'></i>
                  </div>
                  <p className="testimonial__description">
                    They are the best watches that one acquires, also they are always with the latest
                    news and trends, with a very comfortable price and especially with the attention
                    you receive, they are always attentive to your questions.
                  </p>
                  <h3 className="testimonial__date">March 27. 2021</h3>

                  <div className="testimonial__perfil">
                    <img src="assets/img/testimonial3.jpg" alt="" className="testimonial__perfil-img"/>

                      <div className="testimonial__perfil-data">
                        <span className="testimonial__perfil-name">Raul Zaman</span>
                        <span className="testimonial__perfil-detail">Director of a company</span>
                      </div>
                  </div>
                </div>
              </div>

              <div className="swiper-button-next">
                <i className='bx bx-right-arrow-alt'></i>
              </div>
              <div className="swiper-button-prev">
                <i className='bx bx-left-arrow-alt'></i>
              </div>
            </div>

            <div className="testimonial__images">
              <div className="testimonial__square"></div>
              <img src="assets/img/testimonial.png" alt="" className="testimonial__img"/>
            </div>
          </div>
        </section>


        <section className="new section container" id="new">
          <h2 className="section__title">
            New Arrivals
          </h2>

          <div className="new__container">
            <div className="swiper new-swiper">
              <div className="swiper-wrapper">
                <article className="new__card swiper-slide">
                  <span className="new__tag">New</span>

                  <img src="assets/img/new1.png" alt="" className="new__img"/>

                    <div className="new__data">
                      <h3 className="new__title">Longines rose</h3>
                      <span className="new__price">$980</span>
                    </div>

                    <button className="button new__button">ADD TO CART</button>
                </article>

                <article className="new__card swiper-slide">
                  <span className="new__tag">New</span>

                  <img src="assets/img/new2.png" alt="" className="new__img"/>

                    <div className="new__data">
                      <h3 className="new__title">Jazzmaster</h3>
                      <span className="new__price">$1150</span>
                    </div>

                    <button className="button new__button">ADD TO CART</button>
                </article>

                <article className="new__card swiper-slide">
                  <span className="new__tag">New</span>

                  <img src="assets/img/new3.png" alt="" className="new__img"/>

                    <div className="new__data">
                      <h3 className="new__title">Dreyfuss gold</h3>
                      <span className="new__price">$750</span>
                    </div>

                    <button className="button new__button">ADD TO CART</button>
                </article>

                <article className="new__card swiper-slide">
                  <span className="new__tag">New</span>

                  <img src="assets/img/new4.png" alt="" className="new__img"/>

                    <div className="new__data">
                      <h3 className="new__title">Portuguese rose</h3>
                      <span className="new__price">$1590</span>
                    </div>

                    <button className="button new__button">ADD TO CART</button>
                </article>
              </div>
            </div>
          </div>
        </section>


        <section className="newsletter section container">
          <div className="newsletter__bg grid">
            <div>
              <h2 className="newsletter__title">Subscribe Our <br/> Newsletter</h2>
              <p className="newsletter__description">
                Don't miss out on your discounts. Subscribe to our email
                newsletter to get the best offers, discounts, coupons,
                gifts and much more.
              </p>
            </div>

            <form action="" className="newsletter__subscribe">
              <input type="email" placeholder="Enter your email" className="newsletter__input"/>
                <button className="button">
                  SUBSCRIBE
                </button>
            </form>
          </div>
        </section>
      </main>
</body>
  );
}

export default App;
*/




import React, {useEffect, useState} from "react";

import './App.css';
import imgg from './assets/favicon.ico'
import Cart from "./component/page/cart";
import Home from "./component/page/home";
import History from "./component/page/history";
import PopupProduct from "./component/pop up not used/pop-product";
import PopupCart from "./component/pop up not used/pop-cart";
import {Badge} from "@material-tailwind/react";
import CheckIcon from "@heroicons/react/20/solid/CheckIcon";
import Package from "./component/page/package";


import {Link, Routes, Route, BrowserRouter as Router} from 'react-router-dom';
import PopProduct from "./component/popUp/pop-product";
import SmallHeader from "./component/header/small-device-header";
import LargeHeader from "./component/header/large-device-header";




import { createBrowserHistory } from "history";
import Conform from "./component/page/confirm";
import Confirm from "./component/page/confirm";
import Decompress from "./component/decompress/decompress";
const history = createBrowserHistory();

// Set scroll restoration behavior to "manual"
/*history.scrollRestoration = "manual";*/

export default function App() {




  const showTopMenu = () => {
     const toggle = document.getElementById('nav-toggle')
    const nav = document.getElementById('nav-menu')

    if(toggle && nav){
        toggle.addEventListener('click', ()=>{
            // We add the show-menu class to the div tag with the nav__menu class
            nav.classList.toggle('show-menu')
        })
    }
  }

      const handleDragStart = (event) => {
    event.preventDefault(); // Prevent drag-and-drop behavior on anchor elements
  };

  const handleKeyDown = (event) => {
    if (event.shiftKey) {
      event.preventDefault(); // Prevent opening links in a new tab when shift is pressed
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault(); // Prevent the default context menu behavior
  };

  const dd =()=>{
    const themeButton = document.getElementById('theme-button')
    const darkTheme = 'dark-theme'
    const iconTheme = 'bx-sun'

// Previously selected topic (if user selected)
const selectedTheme = localStorage.getItem('selected-theme')
const selectedIcon = localStorage.getItem('selected-icon')

// We obtain the current theme that the interface has by validating the dark-theme class
const getCurrentTheme = () => document.body.classList.contains(darkTheme) ? 'dark' : 'light'
const getCurrentIcon = () => themeButton.classList.contains(iconTheme) ? 'bx-moon' : 'bx-sun'

// We validate if the user previously chose a topic
if (selectedTheme) {
  // If the validation is fulfilled, we ask what the issue was to know if we activated or deactivated the dark
  document.body.classList[selectedTheme === 'dark' ? 'add' : 'remove'](darkTheme)
  themeButton.classList[selectedIcon === 'bx-moon' ? 'add' : 'remove'](iconTheme)
}


 document.body.classList.toggle(darkTheme)
    themeButton.classList.toggle(iconTheme)
    // We save the theme and the current icon that the user chose
    localStorage.setItem('selected-theme', getCurrentTheme())
    localStorage.setItem('selected-icon', getCurrentIcon())
  }


  const [page, setPage] = useState(<Home/>)
    const [activeMenu, setActiveMenu] = useState('Home');

     const handlePageChange = (newPage, menuName) => {
         PopupProduct.hide()
         PopupCart.hide()
    setPage(newPage);

     setActiveMenu(menuName);

  };

     /* const menuItems = [
    { name: 'Home', component: <Home />, icon:'Home'},
           { name: 'Package', component: <Package />, icon:'Package' },
    { name: 'Kikapu', component: <Cart />, icon:'Cart' },
    { name: 'History', component: <History />, icon:'History' },
  ];
*/

     const menuItems = [
    { name: 'Home', path: '/', component: <Home />, icon: 'Home' },
    { name: 'Package', path: '/package', component: <Package />, icon: 'Package' },
    { name: 'Kikapu', path: '/cart', component: <Cart />, icon: 'Cart' },
    { name: 'Msaada', path: '/history', component: <History />, icon: 'help-circle' },
  ];


       useEffect(() => {
    // Retrieve the theme and icon preferences from local storage
    const selectedTheme = localStorage.getItem("selected-theme");
    const selectedIcon = localStorage.getItem("selected-icon");

    // Apply the theme and icon preferences if they exist
    if (selectedTheme) {
      document.body.classList[selectedTheme === "dark" ? "add" : "remove"](
        "dark-theme"
      );
      document.getElementById("theme-button").classList[
        selectedIcon === "bx-moon" ? "add" : "remove"
      ]("bx-sun");
    }
  }, []);

  /* const [popupsHidden, setPopupsHidden] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!popupsHidden) {
        // Hide PopupProduct and PopupCart if they haven't been hidden yet
        PopupProduct.hide();
        PopupCart.hide();

        // Update the flag to indicate that the popups have been hidden
        setPopupsHidden(true);

        // Prevent the default behavior of the browser's back button
        event.preventDefault();

        // Optionally, you can provide a custom message
        event.returnValue = 'Are you sure you want to leave this page?';
      }
    };

    // Attach the event listener when the component mounts
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [popupsHidden]);
*/








document.addEventListener("DOMContentLoaded", function () {
  const specificInput = document.getElementById("decode");

  if (specificInput) {
    specificInput.addEventListener("contextmenu", function (e) {
      // Allow context menu on this specific input element
      e.stopPropagation();
    });
  }
});
  return (
       <Router history={history} >
    <div className={'select-none no-select'} id={'me'}>

      <a href="#" className="scrolltup" id="scollup">
        <i className="bx bx-chevron-up scrolltop__icon"></i>
      </a>

      <header className="header l-header" id="header">
        <nav className="nav container">
          <div className="nav__logo">
            <span></span>





           {/* __________________header ya small pekee_____________--*/}
        {/* <div >
  <header className="header sm:hidden" id="header">
    <nav className="nav container">
      <i className='bx bxs-watch nav__logo-icon'>
        <div  className="nav__logo" style={{ marginLeft: '4px' }}>
          Maokoto OG
        </div>
      </i>

      <div className="nav__menuT" id="nav-menu">

        <ul className="nav__listT " >
          {menuItems.map((menuItem) => (
            <li  className="nav__item" key={menuItem.name}>
              <Link
                to={menuItem.path}
                onClick={() => handlePageChange(menuItem.component, menuItem.name)}
                className={`nav__linkT ${
                  activeMenu === menuItem.name ? 'active-link' : 'active-link'
                }`}
              >
                <i
                  className={`bx bx-${menuItem.icon.toLowerCase()} nav__icon ${
                    menuItem.icon === 'Package' ? 'text-blue-500 bx-fade-up' : ''
                  }`}
                ></i>
                {menuItem.name === 'Kikapu' ? (
                  <span className="nav__name">
                    <Badge
                      style={{
                        marginTop: '-19px',
                        marginLeft: '25px',
                        borderRadius: '100%',
                        fontSize: '11px',
                        padding: '2px',
                        fontWeight: 'bold',
                      }}
                      content={<div style={{}}>4</div>}
                      className="bg-gradient-to-tr from-green-400 bx-burst text-white to-green-600 border-2 border-white shadow-lg shadow-black/20"
                    >
                      {menuItem.name}
                    </Badge>
                  </span>
                ) : (
                  <span
                    className={`nav__name ${
                      menuItem.name === 'Package' ? 'bx-burst ' : ''
                    }`}
                  >
                    {menuItem.name}
                  </span>
                )}
              </Link>
            </li>
          ))}
          <li className="nav__item   flex items-center justify-center"> <i className='bx bx-moon  ' onClick={() => dd()} id="theme-button" style={{ fontSize: '24px', marginTop:'6px' }}></i> </li>
        </ul>

      </div>

      <div className="nav__btns">
        <i
          className='bx bx-moon'
          style={{ fontSize: '24px' }}
          onClick={() => dd()}
          id="theme-button"
        ></i>

        <div className="nav__shop" id="cart-shop">
          <i className='bx bx-shopping-bag'></i>
        </div>

        <div onClick={()=>localStorage.clear()} className="nav__toggle" id="nav-toggle">
          <i className='bx bx-grid-alt'></i>
        </div>
      </div>
    </nav>
  </header>
</div>*/}

            <SmallHeader menuItems={menuItems} activeMenu={activeMenu}/>

          </div>



 {/* __________________header ya large pekee_____________--*/}
 <LargeHeader menuItems={menuItems} activeMenu={activeMenu}/>














        </nav>
      </header>

      <main className="l-main"  >

 <Routes history={history}>
          {menuItems.map((menuItem) => (
            <Route
              key={menuItem.name}
              path={menuItem.path}
              element={menuItem.component}
            />
          ))}

          {/*kwa single item*/}
          {/* <Route path="/popup/:d" element={<PopProduct />} />*/}

         {/* kwa object*/}
           <Route path="/popup/" element={<PopProduct />} />
            <Route path="/confirm/" element={<Confirm />} />
             <Route path="/mwalwama/" element={<Decompress />} />
        </Routes>
          {/*{page}*/}

      </main>
    </div>


       </Router>
  );
}
                                {/* <li><i className='bx bx-moon change-theme' onClick={()=>this.dd()} id="theme-button"></i></li>*/}







